
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/userflow",
      function () {
        return require("private-next-pages/destinations/userflow.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/userflow"])
      });
    }
  